import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
// Models
import { OperationNatureEnum } from '@mocca-technologies/model';

@Component({
    selector: 'app-custom-cell',
    template: `
    <div class="activity-cell-display" (click)="openSelector($event)">
        {{ getDisplayValue() }}
    </div>
    `,
    styles: [`
      .activity-cell-display {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 4px;
        cursor: pointer;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
    `]
})

export class OperationNatureSelectorCellComponent implements ICellRendererAngularComp {

    /**
     * Variables
     */

    activityOptions: {value: string, label: string}[] = [];
    selectedActivity: {value: string, label: string};

    params: ICellRendererParams;

    /**
     * This method is used to initialize the cell renderer
     * @param params
     */
    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.selectedActivity = params.value || '';

        this.activityOptions = Object.entries(OperationNatureEnum)
        .filter(([key]) => key !== 'UNKOWN')
        .map(([key, value]) => ({
            value: key,
            label: value
        }));

        const activityValue = params.value;

        if (activityValue) {

            const matchingOption = this.activityOptions.find( option =>
                option.value === activityValue
            );

            this.selectedActivity = matchingOption || { value: '', label: '(None)' };

        } else {
            this.selectedActivity = { value: '', label: '(None)' };
        }
    }

    /**
     * This method is used to refresh the values.
     * @param params
     * @returns
     */
    refresh(params: ICellRendererParams): boolean {
        this.params = params;

        if (params.value) {

            const matchingOption = this.activityOptions.find( option =>
                option.value === params.value
            );

            this.selectedActivity = matchingOption || { value: '', label: '(None)' };

        } else {

            this.selectedActivity = { value: '', label: '(None)' };

        }

        return true;
    }

    /**
     * This method is used to get the display value of the cell.
     * @returns
     */
    getDisplayValue(): string {
        return this.selectedActivity?.label || '(None)';
    }

    /**
     * THis method is used to initialize and open the selector in an alert.
     * @param event
     */
    async openSelector(event: Event) {
        event.stopPropagation();

        const alertController = this.params.context.alertController;

        const alert = await alertController.create({
            header: 'Select Operation Nature',
            cssClass: 'opNatureAlert',
            inputs: this.activityOptions.map(option => ({
                name: option?.value,
                type: 'radio',
                label: option?.label,
                value: option,
                checked: option?.value === this.selectedActivity.value
            })),
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Save',
                    handler: (value) => {
                        this.selectedActivity = value;
                        this.saveValue();
                    }
                }
            ]
        });

        await alert.present();
    }

    /**
     * This method is used to save the selected value
     */
    saveValue(): void {
        if (this.params.context && this.params.context.componentParent) {
            this.params.context.componentParent.saveOperationNature(
                this.params.node.data,
                this.selectedActivity
            );
        }
    }
}
